import type { CategoryContent } from './row.js';

export const FRENCH_HISTORY: CategoryContent = {
  bscba: [
    [
      'Which Frankish dynasty, known for their "long-haired kings," ruled before the Carolingians?',
      [
        'The Merovingians',
        'The Visigothic dynasty',
        'The Ostrogothic dynasty',
        'The Vandal dynasty',
      ],
      0,
      'The Merovingians (481–751) were the first Frankish dynasty, named after the legendary ancestor Merovech. Their power gradually declined as Mayors of the Palace grew stronger.',
    ],
    [
      'What was the significance of Charlemagne\'s coronation on Christmas Day 800?',
      [
        'He was crowned Holy Roman Emperor',
        'He became the first Christian king of France',
        'He declared himself Pope of the Western Church',
        'He conquered Rome and established a new religious capital',
      ],
      0,
      'Charlemagne\'s coronation by Pope Leo III established the Holy Roman Empire and symbolized the fusion of Frankish political power with papal authority in Western Christendom.',
    ],
    [
      'Which dynasty, founded by Hugh Capet, established Paris as its power base and gradually dominated France?',
      [
        'The Capetian dynasty',
        'The Carolingian dynasty',
        'The Anjou dynasty',
        'The Burgundian dynasty',
      ],
      0,
      'The Capetians (987–1328) built their kingdom from the Île-de-France and used feudal relationships and marriages to expand their domain across centuries.',
    ],
    [
      'What was the primary cause of the Hundred Years\' War between England and France?',
      [
        'English claims to the French throne',
        'French invasion of English territories in Britain',
        'Religious differences between English Catholics and French Protestants',
        'Trade disputes over control of Mediterranean ports',
      ],
      0,
      'The Hundred Years\' War (1337–1453) arose from English dynastic claims to France stemming from the Norman Conquest and Angevin holdings in Aquitaine and Normandy.',
    ],
    [
      'Who was Joan of Arc and what was her role in the Hundred Years\' War?',
      [
        'A French peasant girl who led French troops',
        'An English general who defeated French armies at Crécy',
        'A French noblewoman who negotiated peace treaties with England',
        'A French scholar who taught military strategy to the dauphin',
      ],
      0,
      'Joan of Arc (1412–1431) claimed divine inspiration, rallied French forces, secured the dauphin\'s coronation, and was later executed by the English and their French allies.',
    ],
    [
      'What system of governance characterized the reign of Louis XIV?',
      [
        'Absolute monarchy, centered on the king',
        'Constitutional monarchy with a powerful parliament',
        'Democratic republic with elected officials',
        'Feudal system with powerful independent nobles',
      ],
      0,
      'Louis XIV (r. 1643–1715) embodied absolute monarchy, famously asserting "L\'État, c\'est moi." He centralized power, moved the court to Versailles, and weakened the nobility\'s independence.',
    ],
    [
      'What was the Edict of Nantes (1598) and whom did it protect?',
      [
        'Henry IV\'s decree granting religious toleration to Huguenots',
        'Louis XIV\'s law abolishing all Protestant churches in France',
        'A papal bull establishing the authority of the Pope in France',
        'A feudal contract between the king and French nobility',
      ],
      0,
      'The Edict of Nantes granted Huguenots (French Protestants) religious freedom and political rights. Louis XIV revoked it in 1685, intensifying persecution and causing emigration.',
    ],
    [
      'What event in 1789 is considered the symbolic start of the French Revolution?',
      [
        'The storming of the Bastille',
        'The execution of King Louis XVI',
        'The Declaration of the Rights of Man',
        'The convocation of the Estates-General',
      ],
      0,
      'On July 14, 1789, Parisians stormed the Bastille, a symbol of royal tyranny. The event is celebrated as the beginning of the Revolution and is France\'s national holiday.',
    ],
    [
      'Which period saw the rapid executions during the French Revolution, including King Louis XVI?',
      [
        'The Reign of Terror under Robespierre',
        'The Directoire period of moderate republicanism',
        'The Consulate under Napoleon\'s leadership',
        'The Restoration under Louis XVIII',
      ],
      0,
      'The Reign of Terror (1793–1794) under Maximilien Robespierre saw mass executions by guillotine, including Louis XVI, Marie Antoinette, and thousands of perceived enemies of the Revolution.',
    ],
    [
      'How did Napoleon Bonaparte rise to power in France?',
      [
        'The Coup of 18 Brumaire in 1799',
        'By being elected president in a democratic vote',
        'By inheriting the throne from King Louis XVI',
        'By leading a popular peasant uprising against the nobility',
      ],
      0,
      'The Coup of 18 Brumaire (November 9, 1799) brought Napoleon to power as Consul. He exploited the Directoire\'s unpopularity and weakness amid war and economic crisis.',
    ],
    [
      'What was the primary purpose of the Napoleonic Code introduced in 1804?',
      [
        'To establish a unified system of civil law',
        'To confirm the absolute power of the Catholic Church in all legal matters',
        'To restore feudal privileges to the French aristocracy',
        'To establish a democratic legislative body independent of the executive',
      ],
      0,
      'The Napoleonic Code standardized French law, replacing a patchwork of feudal and local customs. It influenced legal systems across Europe and emphasized secular civil rights.',
    ],
    [
      'How did the Congress of Vienna (1814–1815) respond to Napoleon\'s defeat?',
      [
        'It restored the Bourbon monarchy and redrew European boundaries',
        'It eliminated France entirely and divided its territory among neighboring nations',
        'It established a democratic republic throughout Europe',
        'It appointed Napoleon\'s son as ruler of a weakened France',
      ],
      0,
      'The Congress of Vienna restored the Bourbon monarchy and the balance of power in Europe. France was reduced to its 1789 borders but remained a major nation under conservative management.',
    ],
    [
      'What was the outcome of the 1848 Revolution in France?',
      [
        'It established the Second Republic and expanded voting rights',
        'It permanently ended the French monarchy and established a democratic government',
        'It led to the immediate unification of all European states',
        'It restored the Bourbon dynasty to absolute power',
      ],
      0,
      'The 1848 Revolution created the Second Republic, expanded voting rights, and abolished slavery. However, the republic was short-lived; Napoleon III seized power in 1852.',
    ],
    [
      'Which French statesman and military hero led the Free French resistance during World War II?',
      [
        'Charles de Gaulle',
        'Pierre Laval',
        'Philippe Pétain',
        'Jean Monnet',
      ],
      0,
      'Charles de Gaulle (1890–1970) organized the Free French forces, opposed the Vichy regime, and became France\'s leader after liberation. He later founded the Fifth Republic.',
    ],
    [
      'What system of government was established by the Fifth Republic constitution in 1958?',
      [
        'A semi-presidential system with an elected president',
        'An absolute monarchy with ceremonial powers only',
        'A pure parliamentary democracy with no separate executive',
        'A military dictatorship under de Gaulle\'s direct command',
      ],
      0,
      'The Fifth Republic (1958–present) created a semi-presidential system balancing presidential and parliamentary power. It remains France\'s current constitutional framework.',
    ],
  ],
  msc: [
    [
      'Which Merovingian practice of dividing the kingdom equally among sons created chronic instability and regional fragmentation?',
      [
        'Partible inheritance, weakening central royal authority',
        'Primogeniture, which concentrated all wealth in the eldest son',
        'Matrilineal succession, placing power in female regents and their chosen heirs',
        'Elective monarchy, requiring constant competitive campaigns among nobles',
      ],
      0,
      'Partible inheritance meant kingdoms split among heirs, creating Austrasia, Neustria, and Aquitaine. This fragmentation enabled Mayors of the Palace to consolidate power by manipulating succession disputes.',
    ],
    [
      'What military innovation did Pepin III employ to defeat the Lombards and secure papal alliance?',
      [
        'Heavy cavalry tactics using stirrups on horseback',
        'Naval galleys that controlled Mediterranean trade routes to Byzantine territories',
        'Greek fire technology adopted from Byzantine sources for siege warfare',
        'Elephants imported from North Africa for psychological impact against enemies',
      ],
      0,
      'Pepin III (Pepin the Short) deployed heavy cavalry with stirrups, revolutionizing Frankish warfare. His victories over Lombards won papal gratitude and secured his dynasty\'s legitimacy.',
    ],
    [
      'What educational and cultural program did Charlemagne implement to strengthen his empire?',
      [
        'The Carolingian Renaissance, reviving classical learning',
        'A system of secular universities teaching Greek philosophy and rhetoric',
        'Mandatory military academies for training noble officers',
        'Trade schools teaching merchants advanced accounting and navigation',
      ],
      0,
      'Charlemagne\'s Carolingian Renaissance restored classical texts, standardized Latin script (Carolingian minuscule), and promoted literacy among clergy. This cultural revival influenced medieval Europe.',
    ],
    [
      'How did the Treaty of Verdun (843) affect the Carolingian Empire\'s structure and legacy?',
      [
        'It partitioned the empire into three kingdoms',
        'It unified all Frankish territories under a single heir\'s direct rule',
        'It transferred imperial authority entirely to the Byzantine Emperor',
        'It abolished feudalism and established direct royal governance over all regions',
      ],
      0,
      'Verdun divided Charlemagne\'s empire among his grandsons. The partition created proto-France, proto-Germany, and a disputed middle realm, establishing medieval Europe\'s basic political structure.',
    ],
    [
      'What feudal strategy did Philip Augustus (r. 1180–1223) use to expand Capetian domain at Angevin expense?',
      [
        'He confiscated Norman and Angevin lands from John Lackland',
        'He purchased English territories from a succession of bankrupt English kings',
        'He married the daughter of the English king to claim English throne for his heirs',
        'He negotiated trade agreements that isolated English merchants from French ports',
      ],
      0,
      'Philip Augustus exploited John Lackland\'s conflicts with English barons and his loss of Normandy. By 1202, Philip had seized most Angevin French holdings, tripling Capetian territory.',
    ],
    [
      'What religious conflict did the Albigensian Crusade (1209–1229) address in southern France?',
      [
        'It was a crusade against Cathar heretics in Occitania',
        'It was a conflict between French Catholics and Muslim invaders from North Africa',
        'It was a civil war between rival Capetian heirs over the throne',
        'It was a revolt by southern nobles against northern French taxation',
      ],
      0,
      'The Albigensian Crusade destroyed the Cathar heresy in Languedoc and brought wealthy southern territories under direct Capetian rule. The Inquisition consolidated Catholic orthodoxy.',
    ],
    [
      'What role did Joan of Arc\'s trial and execution play in English political legitimacy?',
      [
        'Her condemnation by a pro-English court delegitimized English rule',
        'Her execution permanently demoralized the French and ensured English victory in the Hundred Years\' War',
        'Her trial established English legal authority over French ecclesiastical matters',
        'Her execution unified English and French churches under papal control',
      ],
      0,
      'Joan was tried and burned for heresy by a pro-English court in 1431. Her martyrdom, later used by France, symbolized English oppression and eventually contributed to English loss of France.',
    ],
    [
      'How did the Wars of Religion (1562–1598) reflect conflicts beyond mere sectarian doctrine?',
      [
        'They entailed factional power struggles between Guise and Bourbon families',
        'They were purely theological debates about scriptural interpretation with no political dimension',
        'They were civil wars between peasants and nobility over land redistribution',
        'They were foreign invasions by Spanish and Italian Catholic armies seeking territorial conquest',
      ],
      0,
      'The Wars of Religion involved dynastic rivalry, noble factionalism, and international intervention, with Protestantism and Catholicism as banners for political competition rather than sole causes.',
    ],
    [
      'What economic policy did Jean-Baptiste Colbert implement to strengthen France under Louis XIV?',
      [
        'Mercantilism, controlling commerce and accumulating bullion',
        'Free trade with all European nations and colonial territories',
        'Feudal-style agricultural communes with no central fiscal control',
        'Direct state ownership of all merchant ships and trading companies',
      ],
      0,
      'Colbert\'s mercantilism boosted French manufacturing, built a navy, chartered trading companies, and generated royal revenue through tariffs and colonial trade monopolies.',
    ],
    [
      'What role did the Parlement of Paris (a judicial body, not a legislature) play in opposing 18th-century fiscal reform?',
      [
        'It used its power to block royal edicts on taxation reform',
        'It supported the crown by implementing all proposed fiscal measures',
        'It attempted to establish democratic voting rights for all French subjects',
        'It allied with foreign powers to prevent French state consolidation',
      ],
      0,
      'The Parlement of Paris blocked fiscal edicts through refusal to register them. This judicial obstruction by privileged parlementaires delayed necessary reforms and deepened the fiscal crisis.',
    ],
    [
      'How did enlightenment philosophies, particularly those of Diderot and Rousseau, influence French Revolutionary ideology?',
      [
        'They promoted rational critique of absolute monarchy and religious orthodoxy',
        'They defended feudalism and aristocratic privilege as natural and divinely ordained',
        'They advocated for stronger central monarchy and expanded royal authority',
        'They rejected all forms of social organization as inherently corrupt',
      ],
      0,
      'Enlightenment thinkers attacked arbitrary authority, promoted reason and individual rights, and theorized popular sovereignty. These ideas directly inspired Revolutionary demands for liberty and equality.',
    ],
    [
      'What transformation did the Civil Constitution of the Clergy (1790) attempt, and what resistance did it provoke?',
      [
        'It subordinated the Church to state authority, causing a papal schism',
        'It granted the Church unlimited control over state taxation and legal authority',
        'It abolished all religious institutions and converted churches to public warehouses',
        'It restored feudal church lands and strengthened papal authority over France',
      ],
      0,
      'The Civil Constitution made clergy state employees and subordinated the Church to the state. Pope Pius VI condemned it, splitting French Catholics and fueling counter-revolutionary movements.',
    ],
    [
      'How did the Thermidorian Reaction (July 1794) mark a turning point in the Revolution?',
      [
        'It executed Robespierre, ending the Terror',
        'It reinforced radical Jacobin control and accelerated executions',
        'It restored the Bourbon monarchy to absolute power immediately',
        'It established democratic socialism as France\'s governing ideology',
      ],
      0,
      'The fall of Robespierre on 9 Thermidor ended the Reign of Terror. The Thermidorians established a more conservative, property-based republic that ultimately paved the way for Napoleon.',
    ],
    [
      'What military crisis prompted the Directory\'s invitation to Napoleon and his coup in 1799?',
      [
        'Military losses and royalist uprisings destabilized the Republic',
        'Napoleon voluntarily stepped forward to prevent a foreign monarchy from invading France',
        'The Directory sought to expand democracy through a military revolutionary council',
        'Britain decisively defeated the French fleet, making Napoleon a defensive necessity',
      ],
      0,
      'The Directory faced military defeats, financial collapse, royalist resurgence, and foreign invasion threats. These crises eroded civilian government legitimacy and enabled Napoleon\'s seizure of power.',
    ],
    [
      'How did the Hundred Days (March–June 1815) demonstrate Napoleon\'s enduring appeal and its limits?',
      [
        'He escaped Elba, rallied loyal armies, but lost decisively at Waterloo',
        'He successfully reconquered Europe and established a permanent dynasty',
        'He voluntarily abdicated to restore the Bourbons without military confrontation',
        'He was immediately arrested and executed upon escaping his exile',
      ],
      0,
      'Soldiers flocked to Napoleon\'s banner in 1815, showing his popularity. Yet European armies defeated him at Waterloo, ending his rule and proving that his personal magnetism could not overcome coalition power.',
    ],
  ],
  phd: [
    [
      'What distinguished Austrasian hegemony from Neustrian political structures in the early Merovingian period, and what drove their rivalry?',
      [
        'Austrasia\'s eastern military aristocracy clashed with Neustria\'s western elite over the king',
        'Austrasia was a Roman province while Neustria was entirely Germanic without institutional structures',
        'Neustria always held greater wealth, while Austrasia relied purely on military conquest',
        'They practiced fundamentally different religions, with Austrasia pagan and Neustria Catholic',
      ],
      0,
      'Austrasian and Neustrian nobles competed for control of weak Merovingian kings. This factionalism fragmented the kingdom and enabled Mayors of the Palace—originally Austrasian officials—to consolidate power.',
    ],
    [
      'How did Pepin III\'s introduction of heavy cavalry tactics and the feudal contract system enable Carolingian military supremacy?',
      [
        'Mounted knights with stirrups created a superior professional army',
        'Pepin invented the catapult and gunpowder, giving him technological dominance',
        'He trained exclusively peasant armies using conscription and mass mobilization',
        'He relied entirely on Byzantine mercenaries for all military campaigns',
      ],
      0,
      'Pepin\'s heavy cavalry relied on stirrups, enabling shock tactics. The feudal system bound nobles as vassals obligated to military service, creating a decentralized but coordinated warrior class.',
    ],
    [
      'What pedagogical reforms in the Carolingian Renaissance, particularly Charlemagne\'s Admonitio Generalis, transformed literacy and intellectual culture?',
      [
        'Standardized script and monastery literacy programs disseminated classical texts',
        'He abolished Latin and promoted only Germanic languages for governance',
        'He closed all monasteries and established secular universities exclusively for nobility',
        'He imposed a single dialect of Latin that eliminated regional language variation',
      ],
      0,
      'Charlemagne\'s edicts standardized script, required monasteries to teach reading, and corrected classical texts. Carolingian minuscule enabled easier copying and reading—a technological revolution in information.',
    ],
    [
      'How did Capetian feudal strategies, particularly marriage alliances and systematic vassal litigation, achieve dominance without superior military force initially?',
      [
        'By marrying into major fiefs and exploiting feudal homage',
        'By conquering all territories through military campaigns in the first generation',
        'By purchasing all lands through accumulated merchant wealth',
        'By enforcing mandatory religious conversions to consolidate loyalty',
      ],
      0,
      'Capetians expanded through strategic marriages (gaining Aquitaine, Brittany), leveraging vassalage rights to challenge magnates, and ecclesiastical alliances. Military conquest came later, after political consolidation.',
    ],
    [
      'What structural weakness in the Angevin inheritance system did Philip Augustus exploit to fragment English holdings in France?',
      [
        'John Lackland\'s rebellious barons let Philip confiscate his lands',
        'The Angevin inheritance was too wealthy to defend effectively',
        'English barons voluntarily transferred their French lands to the French crown',
        'A treaty automatically transferred Angevin properties to the Capetian line',
      ],
      0,
      'John\'s unpopularity, his conflict with English barons, and his military incompetence created opportunities. Philip exploited these divisions, confiscating Normandy, Anjou, and Maine under feudal law.',
    ],
    [
      'How did the Mendicant orders\' integration into courtly culture and intellectual networks influence late medieval Capetian governance?',
      [
        'Dominicans and Franciscans provided theological legitimacy and served as royal advisors',
        'They completely separated spiritual and temporal authority, refusing all political involvement',
        'They eliminated Benedictine monasticism and consolidated all religious authority in Rome',
        'They established independent communes that limited royal jurisdictional reach',
      ],
      0,
      'Mendicant friars became confessors, theologians, and political advisors to kings. They linked papal authority with royal legitimacy while promoting education and doctrinal orthodoxy.',
    ],
    [
      'What role did Salic law doctrine play in legitimizing Valois succession and excluding English claims after 1328?',
      [
        'French jurists invoked Salic law against the English claim',
        'Salic law was invented in the 14th century to support English claims against the French',
        'It was a Roman law principle that had nothing to do with medieval succession',
        'It established male elective monarchy rather than hereditary succession',
      ],
      0,
      'After 1328, French legalists weaponized Salic law to exclude Edward III\'s claims (descended through his mother). This doctrine became foundational to French national identity and legitimized Valois rule.',
    ],
    [
      'How did factional struggles during the Fronde (1648–1653)—between the crown, Parlement, and nobility—reshape royal absolutism?',
      [
        'The Fronde prompted Louis XIV to centralize power and disarm the magnates',
        'The Fronde successfully established parliamentary democracy and limited royal authority permanently',
        'The Fronde was a peasant revolt with no impact on elite power structures',
        'It resulted in the immediate restoration of feudal independence to regional nobles',
      ],
      0,
      'The Fronde showed the crown that nobility and the Parlement posed existential threats. Louis XIV\'s response was calculated centralization: he moved the court to Versailles to supervise and disarm magnates.',
    ],
    [
      'What fiscal crisis mechanisms—tax farming, venality of offices, inflation—created the structural deficits that destabilized the late 18th-century monarchy?',
      [
        'Tax farming and venal offices created chronic deficits',
        'The monarchy intentionally spent money to weaken the nobility',
        'France had no actual fiscal crisis; the Revolution was purely ideological',
        'Foreign loans eliminated any financial pressure on the French state',
      ],
      0,
      'Tax farming enriched financiers, not the crown. Venal offices consumed capital. Inflation reduced real revenue while expenses mounted. These structural deficits made the monarchy increasingly insolvent by 1789.',
    ],
    [
      'How did parlementaire resistance to royal edicts—particularly the Maupeou reforms (1768–1774)—embody competing concepts of sovereignty?',
      [
        'Parlements invoked ancient rights; Maupeou abolished them',
        'Parlements were the sole legitimate authority and always defeated royal reforms',
        'The Maupeou reforms were temporary and had no lasting impact',
        'Parlements and the crown always cooperated without conflict',
      ],
      0,
      'Parlements used "remonstrance" to resist edicts, claiming to represent "France\'s ancient constitution." Maupeou expelled them, asserting absolute sovereignty. Their recall (1774) signaled limits to absolutism.',
    ],
    [
      'How did physiocratic theory—asserting that land is the sole source of wealth and proposing a single tax (impôt unique)—influence pre-Revolutionary fiscal debate?',
      [
        'Physiocrats\' fiscal simplification attracted reformers',
        'Physiocrats successfully implemented their system and eliminated all deficits',
        'They had no influence on 18th-century thought and were entirely dismissed',
        'Their theory reinforced tax farming and venal offices',
      ],
      0,
      'Turgot and Necker invoked physiocratic ideas to attack tax farming and monopolies. Physiocratic proposals threatened established financial interests, triggering backlash that weakened reform efforts.',
    ],
    [
      'What constitutional ambiguities and clerical resistance to the Civil Constitution of the Clergy created a counter-revolutionary recruitment base after 1791?',
      [
        'Non-juring priests became symbols of resistance',
        'All clergy eagerly embraced the Civil Constitution without resistance',
        'It had no religious dimension and was purely a fiscal measure',
        'The Constitution unified all clergy behind the Revolutionary government',
      ],
      0,
      'The Civil Constitution split the clergy into "constitutional" and "non-juring" factions. The schism enabled conservative organizers to mobilize rural Catholics around religious grievance, fueling Vendean uprisings.',
    ],
    [
      'How did Robespierre\'s Committee of Public Safety justify escalating terror through discourse on "virtue" and the general will?',
      [
        'Robespierre equated virtue with terror as a moral necessity for the general will',
        'Robespierre was entirely opposed to terror and worked to prevent executions',
        'The Committee used terror without any ideological justification',
        'Robespierre accepted classical liberalism and individual rights without condition',
      ],
      0,
      'Robespierre fused Rousseauean general will with terror: enemies of the people obstructed virtue; eliminating them purified the Republic. This ideology rationalized unprecedented violence as moral action.',
    ],
    [
      'What role did mass conscription (levée en masse, 1793) play in Revolutionary and Napoleonic military dominance, and how did it transform warfare?',
      [
        'Mass conscription created huge, overwhelming armies',
        'Mass conscription was unpopular and never actually implemented',
        'It was used only for the navy and had no effect on land warfare',
        'Other European nations had already implemented larger conscription programs',
      ],
      0,
      'The levée en masse mobilized entire populations as soldiers. Revolutionary and Napoleonic armies numbered 200,000–400,000, far exceeding traditional forces. This transformation made France militarily dominant for two decades.',
    ],
    [
      'How did Napoleon\'s Continental System—a trade embargo against Britain—reshape European economic integration and ultimately generate resistance to French dominance?',
      [
        'The blockade enriched France but impoverished its allies',
        'The Continental System eliminated all international trade permanently',
        'It was universally praised and strengthened French alliances',
        'Britain was economically devastated and surrendered to France',
      ],
      0,
      'The Continental System subordinated allied economies to French interests. Economic hardship in occupied territories bred nationalism and resentment, weakening the coalition that Napoleon had built.',
    ],
  ],
  professor: [
    [
      'How did the compositiones (compositional rules for distributing Merovingian inheritances among Frankish kingdoms) institutionalize a political system that paradoxically weakened central authority while establishing precedent for later feudal hierarchies?',
      [
        'Compositiones fragmented sovereignty via rival heirs',
        'Compositiones completely abolished inheritance and installed elected rulers',
        'They strengthened central monarchy by concentrating all power in one heir',
        'They were imported from Rome and had nothing to do with Frankish custom',
      ],
      0,
      'Compositiones regularized division among heirs but created power vacuums. Mayors exploited fractious succession disputes, using their administrative control to transform themselves from palace officials into quasi-sovereign magnates.',
    ],
    [
      'To what extent did the early Carolingian fiscal crisis—stemming from declining penitential taxation and monetization challenges—constrain Pepin III and Charlemagne\'s military expansion?',
      [
        'Fiscal decline forced Pepin and Charlemagne to grant church lands as fiefs',
        'They had unlimited monetary resources and never faced fiscal constraints',
        'Fiscal policy was irrelevant to military capability or feudalization',
        'The Church funded all military campaigns through tithes and freely donated resources',
      ],
      0,
      'Pepin\'s secularization of church lands (confiscation from laymen, gift to loyal followers) addressed fiscal crises while binding warriors to the crown through land-grant vassalage—a proto-feudal innovation.',
    ],
    [
      'How did late 7th-century Neustrian hegemony under Mayors of the Palace (particularly the Pippinid clan) foreshadow the process by which administrative offices could be weaponized into political dynasties?',
      [
        'Mayors used administrative authority to build war bands and found dynasties',
        'Mayors were temporary officers with no opportunity to accumulate power or found dynasties',
        'Administrative offices were always separate from political power',
        'The Pippinids never held office and had no role in Merovingian governance',
      ],
      0,
      'Mayors of the Palace used their administrative control of the royal household to build patronage networks, distribute lands and offices, and establish hereditary claims. This office-to-dynasty transformation prefigures feudalism.',
    ],
    [
      'What historiographical debate addresses whether Benedictine monastic reform (Cluny, later Cîteaux) enabled or constrained Capetian secular authority in the 11th–13th centuries?',
      [
        'Scholars debate monastic reform\'s effect on royal authority',
        'All monasteries were completely subordinate to the crown at all times',
        'Monasteries and secular rulers had no interactions whatsoever',
        'Benedictine reform was purely a spiritual movement with no political implications',
      ],
      0,
      'Cluny and Cîteaux gained exemptions from local jurisdiction, weakening Capetian control. Yet royal patronage of reform bought legitimacy. The outcome was mixed: ecclesiastical power waxed while Capetians gained prestige.',
    ],
    [
      'How did the Capetian marriage strategy—Eleanor of Aquitaine\'s marriage to Louis VII, then Henry II of England, then control of vast Angevin lands—expose dynastic fragility and create the preconditions for the Hundred Years\' War?',
      [
        'Eleanor\'s remarriage to Henry II installed a rival power',
        'Eleanor\'s marriages had no political significance whatsoever',
        'The marriages unified France permanently without conflict',
        'Eleanor was never involved in political marriages or governance',
      ],
      0,
      'Eleanor brought Aquitaine to Louis, then transferred it to Henry II\'s Angevin empire. Her marriages paradoxically strengthened Capetian prestige while creating the very rival (Angevin) that threatened them for three centuries.',
    ],
    [
      'To what extent did the Mendicant orders\' intellectual independence and urban preaching reshape both papal authority and secular royal ideology in the 13th century?',
      [
        'Mendicants legitimized papal authority for kings',
        'Mendicants were entirely subordinate to local bishops with no independent role',
        'They completely rejected papal authority and advocated revolutionary democracy',
        'They had no connection to urban life or popular preaching',
      ],
      0,
      'Dominicans served papal interests through inquisition; Franciscans emphasized evangelical poverty. Both embedded papal authority within lay religious practice while providing kings with theological legitimacy for expanded jurisdictional claims.',
    ],
    [
      'How did Valois legitimacy doctrine—employing Salic law, descent from Philip III, and symbolic distinction from English "usurpers"—construct a proto-nationalist French identity that endured beyond the dynasty itself?',
      [
        'Valois jurists used Salic law to build a proto-national French identity',
        'National identity existed before the Valois and had nothing to do with them',
        'Salic law was universally accepted and played no role in legitimacy disputes',
        'The Valois had no particular claim to French identity or legitimacy',
      ],
      0,
      'Valois lawyers invoked Salic law, ancestral precedent, and anti-English sentiment to argue that "France" itself was a hereditary entity. This nationalism eventually outlasted the dynasty; the nation survived its kings.',
    ],
    [
      'How did the aristocratic factionalism of the Fronde—disguised within feudal homage relations and parlementaire constitutional claims—expose the ideological contradictions between absolute monarchy and noble privilege?',
      [
        'Frondeurs invoked feudal and parlementaire rights.',
        'The Fronde successfully established democratic government',
        'There were no contradictions between absolutism and noble privilege',
        'The Fronde was purely a peasant revolt',
      ],
      0,
      'Fronde rebels used feudal language and parlementaire constitutionalism to resist Louis XIV. Their suppression demonstrated that absolutism required destroying both feudal reciprocity and jurisdictional pluralism.',
    ],
    [
      'To what extent did the intendant system—centralizing royal bureaucracy bypassing noble authority—represent a transformation of feudal personalism into rational-legal authority?',
      [
        'Intendants were salaried appointees, not hereditary officeholders.',
        'Intendants were feudal vassals with no new features compared to earlier officials',
        'They had no impact on governance or administrative structure',
        'The intendant system strengthened feudal noble independence',
      ],
      0,
      'Intendants replaced venality (heritable offices) with salaried appointment. This transformation from feudal tenure to rational bureaucracy enabled unprecedented state centralization and displaced noble administrative authority.',
    ],
    [
      'How did competing economic theories—physiocratic landed wealth vs. mercantilist commerce/manufacture—structure the ideological battle over fiscal reform in late-18th-century court politics?',
      [
        'Physiocrats attacked tax farming and guild monopolies.',
        'Physiocratic and mercantilist economists agreed completely',
        'Economic theory had no influence on actual political reform',
        'The court had no interest in abstract economic debate',
      ],
      0,
      'Physiocrats represented landed wealth and attacked financiers; mercantilists defended guild monopolies and privileged merchants. Reform attempts faced coordinated opposition because fiscal change threatened multiple elite interests simultaneously.',
    ],
    [
      'What historiographical debate surrounds Gallicanism\'s relationship to French sovereignty: Did ecclesiastical autonomy strengthen or constrain the state\'s religious and jurisdictional authority?',
      [
        'Gallicanism both strengthened and constrained royal authority',
        'Gallicanism completely abolished royal religious authority',
        'The Church maintained absolute independence from all state control',
        'Gallicanism was a purely theological concept with no political implications',
      ],
      0,
      'Gallicanism asserted French independence from Rome while subordinating the Church to the crown. Yet bishops retained exemptions and jurisdictional claims. This created a compromise: religious subjects of state authority, yet not entirely subordinate.',
    ],
    [
      'How did the social composition of the September Massacres (1792)—not organized killing but spontaneous crowd violence—reveal the Revolutionary breakdown of public order and the emergence of terror as an unarticulated popular practice?',
      [
        'Crowds killed clergy and aristocrats without state direction, prefiguring terror',
        'The September Massacres were entirely orchestrated by government and were not spontaneous at all',
        'They had no connection to the Reign of Terror',
        'The crowds were a tiny minority and had negligible historical impact',
      ],
      0,
      'The September Massacres (1,200+ killed by crowds) preceded the Terror. They revealed how revolutionary fear could motivate popular violence without state organization—a precursor to institutionalized terror.',
    ],
    [
      'To what extent did the Vendean uprising (1793–1796) represent a counter-revolutionary peasant revolt vs. a coordinated royalist insurrection, and what does this debate reveal about rural politicization?',
      [
        'Historians debate whether Vendean grievance was autonomous or elite-coordinated',
        'The Vendee was entirely a peasant democratic uprising with no class complications',
        'It was solely an elite conspiracy with no peasant involvement',
        'The Vendean region was not politically active during the Revolution',
      ],
      0,
      'The Vendean rebellion mixed autonomous grievance (conscription resistance, religious defense) with elite coordination. This ambiguity reveals how rural populations became Revolutionary actors while remaining subject to manipulation.',
    ],
    [
      'How did the Directoire\'s structural instability—oscillating between oligarchic and democratic factions, unable to secure stable property or army loyalty—create the preconditions for Napoleon\'s Coup of 18 Brumaire as a rational choice for stabilization?',
      [
        'The unstable Directoire made Napoleon\'s coup a rational choice.',
        'The Directoire was highly stable and faced no crises',
        'The coup was entirely accidental and unplanned',
        'The Directoire could have easily adapted and survived without Napoleon',
      ],
      0,
      'Directorial factionalism, electoral unpredictability, military fragmentation, and fiscal weakness created endemic instability. Bonaparte offered merchant-oligarchs a bargain: military order in exchange for property and commercial security.',
    ],
    [
      'To what extent did the Napoleonic Code\'s codification of property law, abolition of feudalism, and secularization of civil law constitute a Revolution in legal philosophy rather than merely implementing Revolutionary policy?',
      [
        'The Code replaced feudal custom with published statutes.',
        'The Code was purely administrative with no philosophical innovations',
        'It was entirely derived from feudal law without changes',
        'Legal philosophy was irrelevant to the Code\'s construction',
      ],
      0,
      'The Code\'s systematic, written, published format replaced the opacity and customary variation of feudal law. This shift from unwritten custom to rationalized codes transformed legal authority itself—a methodological revolution.',
    ],
  ],
};
